/**
 * Resolution	DataType	Format	                  Example	    API	                        Component	      Field Name Suffix
 * isoDate	  string	  yyyy-MM-dd (ISO format)	  2017-04-20	luxon.DateTime.toISODate()	IsoDatePicker	  isoDate
 */
import { DateTime, Duration } from "luxon";
import { getTimezone } from "..";
import { getDateTime } from "./getDateTime";

const now = (args: { timezone: string }): string => {
  const { timezone } = args;
  return getDateTime.now({ timezone }).toISODate()!;
};

const nowLocal = (): string => {
  return getDateTime.now({ timezone: getTimezone.forLocal()! }).toISODate()!;
};

const fromIsoDateTimeUtc = (args: { isoDateTimeUtc: string; timezone: string }): string => {
  const { isoDateTimeUtc, timezone } = args;
  return getDateTime.fromIsoDateTimeUtc({ isoDateTimeUtc, timezone }).toISODate()!;
};

const fromDateTime = (args: { dateTime: DateTime; timezone: string }): string => {
  const { dateTime, timezone } = args;
  return dateTime.setZone(timezone).toISODate()!;
};

const fromJsDate = (args: { jsDate: Date; timezone: string }): string => {
  const { timezone } = args;
  const dateTime = getDateTime.fromJsDate(args);
  return dateTime.setZone(timezone).toISODate()!;
};

const fromCurrentPlusDays = (args: { currentDateTime: DateTime; plusDays: number; timezone: string }): string => {
  const { currentDateTime, plusDays, timezone } = args;
  // Throw error because luxon.DateTime.plus allows negative values
  if (plusDays < 0) throw Error("Plus days should be a positive number");
  return currentDateTime.setZone(timezone).plus({ days: plusDays }).toISODate()!;
};

const fromIsoDateTimeUtcAndDuration = (args: {
  isoDateTimeUtc: string;
  durationObject: Duration;
  timezone: string;
}): string => {
  return getDateTime.fromIsoDateTimeUtc(args).plus(args.durationObject).toISODate()!;
};

export const getIsoDate = {
  now,
  nowLocal,
  fromIsoDateTimeUtc,
  fromDateTime,
  fromJsDate,
  fromCurrentPlusDays,
  fromIsoDateTimeUtcAndDuration,
};
